// extracted by mini-css-extract-plugin
export default {"container":"nl639ykX9Jj9JquZP5NA","empty":"ZyN0EkWUeFMuZOL_UTTs","desks":"TSkgZCZjTpAw0jKpyqkO"};